import React from "react";
import "./Navbar.css";

function Navbar(props) {
  return (
    <div className="nav_wrapper">
      <div
        className={
          props.type === "primary"
            ? "navbar navbar_black"
            : "navbar navbar_grey"
        }
      >
        <div className="navbar_left_section">
          <div className="navbar_left_section_logo">
            <div className="make_extra_bold">

            Narayan Soni
            </div>
          </div>
        </div>
        <div className="navbar_right_section">
        <a href="#home" className="a_nav">    <div className="navbar_right_section_text">Home</div></a>
        <a href="#about" className="a_nav">    <div className="navbar_right_section_text">About</div></a>
        <a href="#contact" className="a_nav">  <div className="navbar_right_section_text">Contact</div></a>
        <a href="#footer" className="a_nav">  <div className="navbar_right_section_text">Footer</div></a>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
